import { ApiProjectType } from "@incendium/api";
import useHasProjectType from "features/project/hooks/useHasProjectType";
import { projectHasTypeFromSettings } from "features/project/utils/projectHasType";
import { useLocalstorageState } from "Hooks/useLocalstorageState";
import { useSelectedProject } from "Hooks";
import moment from "moment";
import { useCallback, useMemo } from "react";

const DISMISS_KEY_PREFIX = "ecom-data-notice-dismissed";

function isWithinFirstWeek(createdAt?: Date): boolean {
  if (!createdAt) {
    return false;
  }
  return moment(createdAt).isAfter(moment().subtract(7, "days"));
}

export function useEcommerceDataNotice() {
  const { selectedProject } = useSelectedProject();
  const hasProjectType = useHasProjectType();
  const projectId = selectedProject?.id;
  const storageKey = projectId
    ? `${DISMISS_KEY_PREFIX}-${projectId}`
    : `${DISMISS_KEY_PREFIX}-placeholder`;

  const [dismissed, setDismissed, isLoaded] = useLocalstorageState(
    storageKey,
    false,
    !projectId,
  );

  const isEcommerce = useMemo(
    () =>
      projectHasTypeFromSettings(
        selectedProject?.settings,
        ApiProjectType.TYPE_ECOMMERCE,
      ) || hasProjectType(ApiProjectType.TYPE_ECOMMERCE),
    [selectedProject?.settings, hasProjectType],
  );

  const isNewProject = useMemo(
    () => isWithinFirstWeek(selectedProject?.createdAt),
    [selectedProject?.createdAt],
  );

  const shouldShow =
    !!projectId && isLoaded && isEcommerce && isNewProject && !dismissed;

  const dismiss = useCallback(() => {
    setDismissed(true);
  }, [setDismissed]);

  return { shouldShow, dismiss };
}
